<template>
    <div>
        <ModuleTitleNav :next-module="nextModule" :previous-module="previousModule" class="title-one">
            {{ moduleTitle }}
        </ModuleTitleNav>
        <div class="section-line" />
        <fieldset :disabled="formDisabled">
            <b-row>
                <b-col>
                    <div class="info-text-section-marker">
                        [Sec 135(b)(1)]
                    </div>
                    <div class="info-text">
                        Describe how the college will provide career exploration and career development activities
                        through an organized, systemic framework designed to aid students in making informed plans
                        and decisions about future education and career opportunities and programs of study.
                    </div>
                    <div class="info-text-emphasis">
                        <b-link :to="{name: 'localApplication.WibCollaboration'}">
                            See also Local Application [Sec 134(b)(3)(C)]
                        </b-link>
                    </div>
                    <b-form-textarea v-model="explorationActivities" :rows="3" />
                </b-col>
            </b-row>
        </fieldset>
        <br>
        <b-row>
            <b-col>
                <LocalApplicationModuleActions
                    :is-loading="isSaving"
                    :is-disabled="formDisabled"
                    background-color="#006438"
                    @saveForm="saveForm"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { Log } from '$Shared/@arc/vue-arc';

const storeModuleName = 'careerExplorationAndDevelopment';
// const storeModuleNamespace = 'localApplications/module';

export default {
    name: 'CareerExplorationAndDevelopment',

    props: {
        // formDisabled: { type: Boolean, default: true },
    },

    data() {
        return {
            isSaving: false,
            moduleTitle: 'Career Exploration & Development',
            nextModule: { name: 'localApplication.ProfessionalDevelopment' },
            previousModule: { name: 'localApplication.Section135Instructions' },
        };
    },

    computed: {
        ...mapState('localApplication', {
            currentState: (state) => state.localApplicationData.state.currentState
        }),

        ...mapGetters({
            isAuthorized: 'auth/isAuthorized',
            localApplicationModuleContent: `localApplication/module/${storeModuleName}/content`
        }),

        formDisabled() {
            return !this.isAuthorized('update', 'local_application', this.currentState);
        },

        explorationActivities: {
            get() { return this.localApplicationModuleContent.explorationActivities; },
            set(value) { this.updateContentField({ field: 'explorationActivities', value }); }
        },
    },


    methods: {
        ...mapActions(`localApplication/module/${storeModuleName}`, {
            saveLocalApplicationModule: 'save',
            updateContentField: 'updateContentField'
        }),

        async saveForm() {
            this.isSaving = true;
            try {
                const response = await this.saveLocalApplicationModule();
                this.isSaving = false;
                Log.debug(response, `COMPONENT:${this.name} -> Save module response:`);
            } catch (error) {
                this.isSaving = false;
            }
        }
    }
};
</script>
